"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _intl = require("@kyruus/intl");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _States = require("../../lib/constants/States");
var _Actions = require("../../lib/constants/Actions");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _utils = require("../../lib/utils");
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ProxyBookingControls(_ref) {
  let {
    service,
    intl
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  const {
    ehrPatientList,
    selectedPatientIndex
  } = state.context;
  const patientNames = (0, _react.useMemo)(() => {
    const proxySelectList = (0, _map.default)(ehrPatientList).call(ehrPatientList, (patient, index) => {
      return {
        value: index,
        text: patient.name
      };
    });
    proxySelectList.push({
      value: null,
      text: intl.formatMessage(_messages.default.proxyBookingSomeoneElse)
    });
    return proxySelectList;
  }, [ehrPatientList, intl]);
  const getSelectedItem = _react.default.useCallback(selectedPatientIndex => {
    if (selectedPatientIndex === undefined || selectedPatientIndex === null) {
      // Return the 'Someone Else' item
      return patientNames[patientNames.length - 1];
    }
    return patientNames[selectedPatientIndex];
  }, [patientNames]);
  const itemToString = item => item ? item.text : '';
  const shouldShowProxyBookingDropdown = !state.matches(`${_States.ehrData}.${_States.ehrFormNoDropdown}`);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "EhrProxyBookingControls"
  }, !state.matches(`${_States.ehrData}.${_States.ehrMainFailed}`) && shouldShowProxyBookingDropdown ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Header, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.proxyBookingControlsHeader)), /*#__PURE__*/_react.default.createElement(_styles.ProxySelect, {
    "data-testid": "EhrPatientSelect",
    items: patientNames,
    itemToString: itemToString,
    icon: 'ArrowDown',
    selectedItem: getSelectedItem(selectedPatientIndex),
    disabled: state.matches(_States.pendingEhrPatientDemographics),
    onSelect: item => {
      send({
        type: _Actions.SELECT_PATIENT,
        data: {
          patientIndex: item.value
        }
      });
    }
  }), state.matches(`${_States.ehrData}.${_States.ehrSubFailed}`) && /*#__PURE__*/_react.default.createElement(_styles.InfoBanner, {
    "data-testid": "EhrSubPatientLoadError"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.subPatientDemographicLoadError)), (0, _utils.relatedFailedStateMatchHelper)(state) && /*#__PURE__*/_react.default.createElement(_styles.WarningBanner, {
    "data-testid": "EhrRelatedPatientLoadError"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.relatedPatientDemographicLoadError))) : state.matches(`${_States.ehrData}.${_States.ehrMainFailed}`) ? /*#__PURE__*/_react.default.createElement(_styles.InfoBanner, {
    "data-testid": "EhrMainPatientLoadError"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.mainPatientDemographicLoadError)) : null);
}
ProxyBookingControls.propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  loginProps: (0, _propTypes.shape)({
    showProxyBookingControls: _propTypes.bool
  }),
  // supplied via `injectIntl`
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  })
};
var _default = exports.default = (0, _intl.injectIntl)(ProxyBookingControls);
ProxyBookingControls.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProxyBookingControls",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "loginProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "showProxyBookingControls": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    }
  }
};